import { render, staticRenderFns } from "./FieldsEdit.vue?vue&type=template&id=05542d1d&scoped=true"
import script from "./FieldsEdit.vue?vue&type=script&lang=ts"
export * from "./FieldsEdit.vue?vue&type=script&lang=ts"
import style0 from "./FieldsEdit.vue?vue&type=style&index=0&id=05542d1d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05542d1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05542d1d')) {
      api.createRecord('05542d1d', component.options)
    } else {
      api.reload('05542d1d', component.options)
    }
    module.hot.accept("./FieldsEdit.vue?vue&type=template&id=05542d1d&scoped=true", function () {
      api.rerender('05542d1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminder-layout-editor/FieldsEdit.vue"
export default component.exports